import { render, staticRenderFns } from "./cash.vue?vue&type=template&id=384524a6&"
import script from "./cash.vue?vue&type=script&lang=js&"
export * from "./cash.vue?vue&type=script&lang=js&"
import style0 from "./cash.vue?vue&type=style&index=0&id=384524a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports